import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
//import { PROFILE_CATEGORY,PROFILE_SPECIALITY,PROFILE_REVIEW,SHARE_PROFILE } from 'src/app/constants';
import { PROFILE_REVIEW,SHARE_PROFILE } from 'src/app/constants';
import { CURRENCY } from '../../environments/environment';
import { IBusinessDetail } from '../interface';

interface ICategoryPackages { category: any, packages: IBusinessDetail[] }
interface ICategoryPackagesMap { [key: number]: ICategoryPackages}

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  
})
export class ProfileComponent implements OnInit {

  closeResult = '';
  businessDetailsList:any;
  active:string;
  venID:string;
  deliveryMode:string;
  contactNo:string;
  whatsAppno:string;
  profileDesc:string;
  experience:string;
  qualification:string;
  businessName:string;
  isTeacher:number;
  shortDesc:string;
  addressLineOne:string;
  addressLineTwo:string;
  country:string;
  countryState:string;
  postalCode:string;
  town:string;
  packageList:any;
  id:string;
  batchList:[];
  venGroupTypes:any;
  userID:string;
 // text3:string;
  //text4:string;
  text5:string;
  text6:string;
  currency:string;
  vendor_classes:[];
  socialMediaUrl:string;
  facebookpage:string;
  linkedinpage:string;
  instapage:string;
  twitterPage:string;
  serviceTypeList:any;
  vendorTypes:any;
  vendorTypeName:string;
  specData:any;
  specialities:Array<object>;
  speciality:any;
  specialityName:string;

  otherClassesAvailable: ICategoryPackages[] = []

  teacherImage = 'assets/images/new/user.webp'
 
  constructor(
    private modalService: NgbModal, 
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private helperService:HelperService
  ) { 

    this.venID = this.activatedRoute.snapshot.paramMap.get('venID');
   

  }

  ngOnInit() {    

   // this.text3= PROFILE_CATEGORY;
   // this.text4= PROFILE_SPECIALITY;
    this.text5= PROFILE_REVIEW;
    this.text6 = SHARE_PROFILE;
    this.currency = CURRENCY;

    this.userID = this.helperService.studented_atob(this.helperService.getUserID());
   
    let businessdata = {
      token:this.helperService.studented_atob(this.helperService.getToken()),
      userID:this.userID,
      vendorID:this.venID
    }

    this.apiService.businessDetails(businessdata).subscribe(async (res:any)=>{

      await this.getVendorTypeName();
      this.getSpecialityData();
      
      this.businessDetailsList = res.data.vendorBusinessDetails.data;
      
      this.deliveryMode =  res.data.vendorBusinessDetails.data.deliveryMode;
      
      this.contactNo = res.data.vendorBusinessDetails.data.venPhoneNumber;
      this.whatsAppno = res.data.vendorBusinessDetails.data.venAlternatePhoneNumber;
      this.profileDesc = res.data.vendorBusinessDetails.data.profileDescription;
      this.experience  = res.data.vendorBusinessDetails.data.experience;
      this.qualification = res.data.vendorBusinessDetails.data.qualification;
      this.businessName = res.data.vendorBusinessDetails.data.businessName;
      this.isTeacher = res.data.vendorBusinessDetails.data.isTeacher;
      this.shortDesc = res.data.vendorBusinessDetails.data.shortDescription;
      this.addressLineOne = res.data.vendorBusinessDetails.data.address.addressLineOne;
      this.addressLineTwo = res.data.vendorBusinessDetails.data.address.addressLineTwo;
      this.country = res.data.vendorBusinessDetails.data.address.country;
      this.countryState = res.data.vendorBusinessDetails.data.address.countryState;
      this.postalCode = res.data.vendorBusinessDetails.data.address.postalCode;
      this.town = res.data.vendorBusinessDetails.data.address.town;
      
      this.venGroupTypes = this.helperService.groupBy(res.data.vendorBusinessDetails.data.vendor_type_specialities, 'vendorTypeName');
      
      this.packageList = res.data.vendorBusinessDetails.data.packages;
      this.packageList.forEach(obj => {    

        this.vendorTypes = obj.vendorTypes;
        this.speciality = obj.speciality;
      })

      const allPackages = res.data.vendorBusinessDetails.data.packages as any[];
        const categoryPackages: ICategoryPackagesMap = {} as ICategoryPackagesMap
        allPackages
          .forEach(el => {
            const pack: IBusinessDetail = { ...el, venId: this.venID, imageURL: el.package_images[0], businessName: this.businessName }

            if (categoryPackages.hasOwnProperty(el.vendorTypes)) {
              categoryPackages[el.vendorTypes].packages.push(pack)
            } else {
              categoryPackages[el.vendorTypes] = { category: this.serviceTypeList.find(i => i.id === el.vendorTypes) } as ICategoryPackages
              categoryPackages[el.vendorTypes].packages = [pack]
            }

            
          })

        this.otherClassesAvailable = Object.values(categoryPackages);

        console.log('[ICategoryPackagesMap] : ', this.otherClassesAvailable);

      //this.vendorTypeName = this.helperService.groupBy(res.data.vendorBusinessDetails.data.packages, 'vendorTypes');
     

      this.vendor_classes = res.data.vendorBusinessDetails.data.vendor_classes;
      

      //this.socialMediaUrl = res.data.vendorBusinessDetails.data.facebookPage;
      this.facebookpage = res.data.vendorBusinessDetails.data.facebookPage;  
      this.linkedinpage = res.data.vendorBusinessDetails.data.linkedInPage;
      this.instapage =   res.data.vendorBusinessDetails.data.instagramPage;
      this.twitterPage = res.data.vendorBusinessDetails.data.twitterPage;
      
      if (res.data.vendorBusinessDetails.data.vendor_images.length > 0) {
        this.teacherImage = res.data.vendorBusinessDetails.data.vendor_images[0].imageURL;
      }
      
    });


  }

  async getVendorTypeName(){

    let vendata = {
      
    }
    const res: any = await this.apiService.getVenDetails(vendata).toPromise();
    this.serviceTypeList = res.data.venDetails.data;       

      this.serviceTypeList.forEach(obj => {             
        if( this.vendorTypes == obj.id  ){
           this.vendorTypeName = obj.vendorTypeName;   
          
                 
        }  
                 
       })   
  }

  getSpecialityData(){
    let catspectdata = {
     
    }

    this.apiService.getSpecialityCategory(catspectdata).subscribe((result:any)=>{      
      
      this.specData = result;
      this.specData.forEach((obj) => {    
        
        obj.specialities.forEach((obj1) =>{
          
          if(this.speciality == obj1.id){
            this.specialityName = obj1.specialityName;
          }

        })
        
      });
      

    })
    
  }
  


  open(content) {    
    this.modalService.open(content,  { centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  request(venID){

    
    this.userID = this.helperService.studented_atob(this.helperService.getUserID());
    
    if(this.userID==null){
      this.router.navigateByUrl(`login`);
    }
    else {
      this.router.navigateByUrl(`create-enquiry/`+ venID );
    }
    
  }

  createEnquiry(venID){     
  
    this.userID =this.helperService.studented_atob(this.helperService.getUserID())
    console.log(this.userID); 
  if(this.userID==null){      
      this.router.navigateByUrl(`login`); 
    }
    else {
      this.router.navigateByUrl(`create-enquiry/`+venID);
    }
  }

  createEnrollment(){
  this.userID = this.helperService.studented_atob(this.helperService.getUserID())
   if(this.userID == null){
    this.router.navigateByUrl(`login`); 
   }
   else {
    this.router.navigateByUrl(`create-enrollment`);
   }    
  }

}
